import * as z from 'zod';

export const BranchFormSchema = z.object({
  orgId: z.coerce.number().min(0, 'Org ID must be 0 or more'),
  branchName: z.string().trim().min(1, 'Branch name is required'),
  address: z.string().trim().min(1, 'Address is required'),
  location: z.string().trim().min(1, 'Location is required'),
  phone: z.string().trim().min(1, 'Phone is required'),
  email: z.string().trim().email('Enter a valid email address'),
  accountNumber: z.coerce.number().min(0, 'Account number must be 0 or more'),
  type: z.enum(['SHOP', 'WAREHOUSE']),
  isActive: z.boolean(),
})

export type BranchSchemaT = z.infer<typeof BranchFormSchema>